/* 🤖 this file was generated by svg-to-ts */
export const DfIconTag12: {
  name: 'tag-12';
  data: string;
} = {
  name: 'tag-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M9.919 1c.3 0 .555.105.766.315.21.21.315.466.315.766v2.523c0 .285-.075.611-.225.98-.15.367-.33.656-.54.866L6 10.685c-.21.21-.465.315-.766.315-.3 0-.555-.105-.766-.315L1.315 7.532A1.043 1.043 0 0 1 1 6.766c0-.3.105-.556.315-.766L5.55 1.766c.21-.21.495-.39.855-.54.36-.15.691-.226.991-.226zM8.5 2.429c-.298 0-.55.104-.759.312-.208.208-.312.461-.312.759s.104.55.312.759c.208.208.461.312.759.312s.55-.104.759-.312c.208-.208.312-.461.312-.759s-.104-.55-.312-.759A1.033 1.033 0 0 0 8.5 2.43z"/></svg>`
};
